import InputError from '~/components/inputerror';
import { InputLabel, Label } from '~/components/label';
import React from 'react';

export type Props = {
  label: string;
  children: React.ReactNode;
  id?: string;
  error?: string;
  touched?: boolean;
  noInputLabel?: boolean;
  required?: boolean;
};

export const InputWrapper = (props: Props) => {
  let { label, children, error, touched, id, noInputLabel, required } = props;

  let LabelComponent = noInputLabel ? Label : InputLabel;
  let displayLabel = required ? `${label} *` : label;

  return (
    <LabelComponent title={displayLabel} htmlFor={id}>
      <div className="w-full">{children}</div>
      {error ? <InputError touched={touched}>{error}</InputError> : <div style={{ height: 8 }} />}
    </LabelComponent>
  );
};

export default InputWrapper;
